module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"quitPlaying":"Quit Playing","select":"No Layer","noLayer":"No Layer","setting":"Setting","fullScreen":"FullScreen"},"zh":{"quitPlaying":"退出播放","select":"请选择","noLayer":"无图层","setting":"设置","fullScreen":"全屏"}}')
  delete Component.options._Ctor
}
